module.exports = __webpack_public_path__ + "static/media/img-ovato-coin-front-new.0a08a054.pdf";